import router from "./router";
import {
  getStore
} from "./config/mUtils";

// 根据 navigator.vue 配置的角色菜单项，定义每个角色允许访问的路径白名单
const roleAllowedPaths = {
  // 学生允许访问的路径（基于 navigator.vue 学生菜单及相关页面）
  student: [
    '/studentLanding',
    '/autonomousEnrolment',
    '/addCollectFees/autonomousList',
    '/signCourse',
    '/signDetail', // 签课详情页面
    '/courseCount',
    '/courseSchedule',
    '/videoAppointmentList',
    '/homeworkManage',
    '/homeworkList', // 作业列表页面
    '/homeworkStudentList', // 学生作业列表
    '/studentHomeworkDetail', // 学生作业详情
    '/coursewareManagement',
    '/coursewareFiles', // 课件文件页面
    '/coursewareWeekly', // 课件周次页面
    '/openCourseList',
    '/saServiceList',
    '/studentProfile',
    '/supplementStudentInfo',
    '/pendingContracts',
    '/studentEmailValidation',
    '/studentDisable',
    '/reviewing',
    '/wechatResponse',
    '/payApi/checkpayPaymentResponse',
    '/payApi/alphaPayPaymentResponse',
    '/stripe/response',
  ],
  // 禁止学生访问的路径前缀（更严格的检查）
  studentForbiddenPrefixes: [
    '/admin',
    '/frontDesk',
    '/studyAbroad',
    '/finance',
    '/teacher',
  ]
};

// 检查路径是否匹配白名单或前缀
const isPathAllowed = (path, allowedPaths, forbiddenPrefixes) => {
  // 首先检查是否匹配禁止的前缀（优先级最高）
  if (forbiddenPrefixes && forbiddenPrefixes.some(prefix => path.indexOf(prefix) === 0)) {
    return false;
  }
  
  // 检查是否在允许的路径列表中（精确匹配）
  if (allowedPaths.includes(path)) {
    return true;
  }
  
  // 检查是否匹配允许路径的前缀（用于处理带参数的路径，如 /coursewareFiles/123）
  for (const allowedPath of allowedPaths) {
    if (path.indexOf(allowedPath) === 0) {
      // 确保是完整路径匹配，而不是部分匹配
      // 例如：/coursewareFiles 匹配 /coursewareFiles/123，但不匹配 /coursewareFilesOther
      if (path.length === allowedPath.length || path[allowedPath.length] === '/') {
        return true;
      }
    }
  }
  
  // 对于学生，如果不在白名单中，默认不允许
  return false;
};

const bindNavigationGuards = (Vue) => {
  router.beforeEach(async (to, from, next) => {
    if (!to.meta.requireAuth) { // 判断该路由是否需要登录权限
      next();
      return;
    }
  
    let token = getStore("auth_token");
    let role = getStore('user_role');
    let studentEnable = getStore('user_student_enable');
    let user_student_hasUninputedInfo = getStore("user_student_hasUninputedInfo");
    let user_student_hasWechat = getStore("user_student_hasWechat");
    let user_student_hasUnsignedContracts = getStore("user_student_hasUnsignedContracts");
    
    if (!token) {
      if (from.fullPath.indexOf('admin') > 0) {
        if (to.fullPath != '/admin/') {
          next({
            path: '/admin/',
            //query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        } else {
          next();
        }
      } else {
        if (to.fullPath != '/') {
          next({
            path: '/',
            //query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        } else {
          next();
        }
      }
      return;
    }

    if (Vue.prototype.USERMANAGER.isStudent) {
      const targetPath = to.fullPath.split('?')[0]; // 移除查询参数
      
      // 首先检查路径是否在学生允许的白名单中
      const isAllowed = isPathAllowed(
        targetPath,
        roleAllowedPaths.student,
        roleAllowedPaths.studentForbiddenPrefixes
      );
      
      if (!isAllowed) {
        // 如果路径不在白名单中，阻止访问并重定向到学生首页
        // 检查 from.fullPath 是否也是允许的路径，如果不是则使用默认路径
        const fromPath = from.fullPath ? from.fullPath.split('?')[0] : '';
        const fromIsAllowed = fromPath && isPathAllowed(
          fromPath,
          roleAllowedPaths.student,
          roleAllowedPaths.studentForbiddenPrefixes
        );
        
        next({
          path: fromIsAllowed ? from.fullPath : '/studentLanding',
        });
        return;
      }
      
      // 原有的学生状态检查逻辑
      if (studentEnable == "0" && to.meta.requireEnable) { //如果是已经禁用的学生且试图访问不可用页面
        if (to.fullPath != '/studentDisable' && to.fullPath.indexOf("/wechatResponse") < 0) {
          next({
            path: '/studentDisable',
          });
        } else {
          next();
        }
      } else if (!Vue.prototype.USERMANAGER.studentIsEmailValidated && to.fullPath != '/studentEmailValidation'
        && to.fullPath != '/studentDisable' && to.fullPath.indexOf("/wechatResponse") < 0) {
        next({
          path: '/studentEmailValidation',
        });
      } else if ((user_student_hasUninputedInfo == "1" || !user_student_hasWechat) 
        && to.fullPath != '/studentEmailValidation'&& to.fullPath != '/studentDisable') {

        if (to.fullPath != '/supplementStudentInfo' && to.fullPath.indexOf("/wechatResponse") < 0) {
          next({
            path: '/supplementStudentInfo',
          });
        } else {
          next();
        }
      } else if ( user_student_hasUnsignedContracts == "1" && to.fullPath != '/pendingContracts' 
        && to.fullPath != '/studentEmailValidation'&& to.fullPath != '/studentDisable'
        && to.fullPath != '/supplementStudentInfo' && to.fullPath.indexOf("/wechatResponse") < 0) {
        next({
          path: '/pendingContracts',
        });
      } else {
        next();
      }
  
      return;
    }

    next();
  });
};

export default {
  install(Vue) {
    bindNavigationGuards(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/navigationGuards.js